import styled from '@emotion/styled';
import transparentBackground from 'ud-ui/components/images/transparent-background.jpg';

/**
 * Сцена «Было» / «Стало»: обе одного размера, картинка вписана целиком.
 *
 * Одинаковый бокс и `object-fit: contain` дают один масштаб показа: исходник растягивается
 * так же, как на табло, — мыло видно сразу, а результат ложится рядом в той же рамке.
 * Шахматка — тот же рисунок, что у выбора подложки логотипа: без неё прозрачность не
 * отличить от белого.
 */
export const Stage = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1;
  width: 100%;
  overflow: hidden;
  background: url(${transparentBackground as string});
  border: 1px solid ${({ theme }) => theme.colors.LineSubtle};
  border-radius: ${({ theme }) => theme.radii.card};

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

/** Ветка поверх шахматки — загрузка, прогресс, ошибка: подложка карточки, чтобы текст читался. */
export const StageOverlay = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  height: 100%;
  padding: 16px;
  text-align: center;
  background: ${({ theme }) => theme.colors.SurfaceCard};
  color: ${({ theme }) => theme.colors.InkSecondary};
`;

export const ProgressTrack = styled.div`
  width: 100%;
  height: 6px;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.SurfaceSunken};
  border-radius: ${({ theme }) => theme.radii.pill};
`;

export const ProgressBar = styled.div`
  height: 100%;
  background: ${({ theme }) => theme.colors.AccentNaplesYellow};
  border-radius: ${({ theme }) => theme.radii.pill};
  transition: width 0.2s ease-out;
`;
